// ========================================
// WISHLIST BUTTON SCRIPT - FIXED FOR FILTERS/SORTING
// ========================================

// Function to set up Quick View button listeners
const setupQuickViewListeners = () => {
	const quickViewButtons = document.querySelectorAll("button[aria-label='Quick view'],button[aria-label='Quick View']");
	
	quickViewButtons.forEach(btn => {
		// Skip if already has listener
		if (btn.classList.contains("qv-listener-added")) return;
		btn.classList.add("qv-listener-added");
		
		console.log("Setting up Quick View listener");
		
		btn.addEventListener("click", () => {
			console.log("Called qview");
			const parent = btn.closest(".card__links,.custom-product-slider__actions");
			const wishlistBtn = parent.querySelector("a.wishlist-btn");
			
			if (!wishlistBtn) {
				console.error("Wishlist button not found in parent");
				return;
			}
			
			let wbtn = wishlistBtn && wishlistBtn.dataset.added === "true"
				? "Added"
				: "Add to Wishlist";

			const poll = setInterval(() => {
				const quickModal = document.querySelector(".quick-add-modal.active .product__outer .product__info-container");
				if (quickModal) {
					clearInterval(poll);
					console.log("Quick modal found");

					// Check if button already exists
					let customWishlistBtn = quickModal.querySelector(".hulk-custom-wishlist-btn");
					
					if (!customWishlistBtn) {
						// Create new button
						customWishlistBtn = document.createElement("button");
						customWishlistBtn.innerHTML = `<div class='ho_txt' data-text='${wbtn}'>${wbtn}</div>`;
						customWishlistBtn.className = "hulk-custom-wishlist-btn quick-add custom-product-slider__btn custom-product-slider__btn--primary";
						
						customWishlistBtn.addEventListener("click", () => {
							console.log("Custom wishlist button clicked");
							wishlistBtn.click();
						});

						quickModal.appendChild(customWishlistBtn);
						console.log("Wishlist button added to modal");
					}

					// Function to update the modal button text
					const updateModalButtonText = () => {
						const textSpan = customWishlistBtn.querySelector(".ho_txt");
						if (!textSpan) return;

						const currentState = wishlistBtn.dataset.added === "true";
						const newText = currentState ? "Added" : "Add to Wishlist";

						textSpan.textContent = newText;
						textSpan.dataset.text = newText;
						console.log("Modal button text updated to:", newText);
					};

					// Set up observer to watch the original wishlist button
					const wishlistObserver = new MutationObserver((mutations) => {
						mutations.forEach((mutation) => {
							if (mutation.type === "attributes" && mutation.attributeName === "data-added") {
								console.log("Wishlist state changed:", wishlistBtn.dataset.added);
								updateModalButtonText();
							}
						});
					});

					// Start observing the original wishlist button
					wishlistObserver.observe(wishlistBtn, {
						attributes: true,
						attributeFilter: ["data-added"]
					});

					// Update immediately in case state changed before observer was set up
					updateModalButtonText();

					// Clean up observer when modal closes
					const modalCloseObserver = new MutationObserver(() => {
						const activeModal = document.querySelector(".quick-add-modal.active");
						if (!activeModal) {
							wishlistObserver.disconnect();
							modalCloseObserver.disconnect();
							console.log("Modal closed, observers disconnected");
						}
					});

					const modalElement = document.querySelector(".quick-add-modal");
					if (modalElement) {
						modalCloseObserver.observe(modalElement, {
							attributes: true,
							attributeFilter: ["class"]
						});
					}
				}
			}, 100);
			
			// Safety timeout
			setTimeout(() => {
				clearInterval(poll);
			}, 5000);
		});
	});
	
	console.log(`Set up ${quickViewButtons.length} Quick View buttons`);
};

// ========================================
// WISHLIST BUTTON TEXT UPDATER (Main Page)
// ========================================

const updateButtonText = (btn) => {
	const textSpan = btn.querySelector(".ho_txt");
	if (!textSpan) return;

	const isAdded = btn.dataset.added === "true";
	textSpan.textContent = isAdded ? "Added" : "Add to Wishlist";
	textSpan.dataset.text = isAdded ? "Added" : "Add to Wishlist";
};

// Observe a single wishlist button
const observeWishlistButton = (btn) => {
	// Prevent double observing
	if (btn.classList.contains("wishlist-observed")) return;
	btn.classList.add("wishlist-observed");

	// Initial update
	updateButtonText(btn);

	const observer = new MutationObserver((mutations) => {
		mutations.forEach((mutation) => {
			if (mutation.type === "attributes" && mutation.attributeName === "data-added") {
				updateButtonText(mutation.target);
			}
		});
	});

	observer.observe(btn, {
		attributes: true,
		attributeFilter: ["data-added"]
	});
};

// Initialize all current buttons
const initWishlistObserver = () => {
	const buttons = document.querySelectorAll(
		".quick-add .wishlist-btn, .custom-product-slider__btn1 .wishlist-btn"
	);

	buttons.forEach((btn) => {
		observeWishlistButton(btn);
	});
};

// Observe the page for newly added HTML (filters, sliders, ajax, etc.)
const observeDynamicContent = () => {
	const body = document.body;

	const pageObserver = new MutationObserver(() => {
		console.log("DOM changed - rescanning for buttons");
		// Re-scan whenever new HTML is injected
		initWishlistObserver();
		// IMPORTANT: Re-setup Quick View listeners for new buttons
		setupQuickViewListeners();
	});

	pageObserver.observe(body, {
		childList: true,
		subtree: true
	});
};

// Initialize everything on page load
window.addEventListener("load", function () {
	console.log("Page loaded - initializing");
	setupQuickViewListeners(); // Setup Quick View buttons
	initWishlistObserver(); // Setup wishlist buttons
	observeDynamicContent(); // Watch for DOM changes
});

// Backup: Also initialize on DOMContentLoaded
if (document.readyState === "loading") {
	document.addEventListener("DOMContentLoaded", function() {
		console.log("DOMContentLoaded - initializing");
		setTimeout(() => {
			setupQuickViewListeners();
			initWishlistObserver();
			observeDynamicContent();
		}, 500);
	});
} else {
	console.log("Document already loaded - initializing immediately");
	setupQuickViewListeners();
	initWishlistObserver();
	observeDynamicContent();
}